import React from "react";

function Icon() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20">
      <g fill="none" stroke="#757575" strokeWidth="1.5" data-name="Ellipse 661">
        <circle cx="10" cy="10" r="10" stroke="none" />
        <circle cx="10" cy="10" r="9.25" />
      </g>
      <path
        fill="none"
        stroke="#757575"
        strokeWidth="1.5"
        d="M1 7h18"
        data-name="Line 819"
      />
      <path
        fill="none"
        stroke="#757575"
        strokeWidth="1.5"
        d="M1 13h18"
        data-name="Line 820"
      />
      <path
        fill="none"
        stroke="#757575"
        strokeWidth="1.5"
        d="M9.7.565a17.148 17.148 0 00-3.192 9.984 14.376 14.376 0 003.422 8.807"
        data-name="Path 5693"
      />
      <path
        fill="none"
        stroke="#757575"
        strokeWidth="1.5"
        d="M10.228 19.395a17.148 17.148 0 003.192-9.984A14.376 14.376 0 009.998.604"
        data-name="Path 5694"
      />
    </svg>
  );
}

export default Icon;
